import { Avatar, Box, Typography } from '@mui/material'
import React from 'react'
import { getEmojiSpecies, getReadableSex, getReadableSpecies } from '../../domain/Animal/AnimalDisplay'
import { GuestAdoptionCheckoutDto } from '../../interactors/clients/GuestAdoptionsClient'
import { findGoodAnimalProfileURL } from '../../utils/findGoodAnimalProfilURL'
import { GuestAdoptionCard } from './GuestAdoptionLayout'

interface Props {
  checkout: GuestAdoptionCheckoutDto
  children?: React.ReactNode
}

export const GuestAdoptionRecap: React.FC<Props> = ({ checkout, children }) => {
  const { animal, organization } = checkout

  const animalDetails = [
    animal.species ? getReadableSpecies(animal.species) : undefined,
    animal.breed,
    animal.sex ? getReadableSex(animal.sex) : undefined,
  ].filter((detail): detail is string => Boolean(detail))

  return (
    <GuestAdoptionCard>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Avatar
          src={findGoodAnimalProfileURL(animal.profileImageKey ?? undefined)}
          alt={animal.name}
          sx={{ width: 80, height: 80, fontSize: '40px', backgroundColor: 'rgba(210, 233, 247, 1)' }}
        >
          {(animal.species && getEmojiSpecies(animal.species)) || '🐾'}
        </Avatar>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0 }}>
          <Typography variant="h2" component="p">
            {animal.name}
          </Typography>
          {animalDetails.length > 0 && (
            <Typography variant="body2" sx={{ color: '#696B6D' }}>
              {animalDetails.join(' · ')}
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '10px',
          borderTop: '1px solid #CCCCCC',
          pt: 2,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="body2" sx={{ color: '#696B6D', fontSize: '13px' }}>
            Adoption proposée par
          </Typography>
          <Typography variant="h2" component="p" sx={{ color: '#4f4f4f', fontSize: '15px' }}>
            {organization.name}
          </Typography>
        </Box>
        <Avatar
          src={`https://logo-customer-images.s3.eu-west-3.amazonaws.com/${organization.id}.jpg`}
          alt={organization.name}
          sx={{ width: 42, height: 42 }}
        >
          {organization.name.charAt(0)}
        </Avatar>
      </Box>
      {children}
    </GuestAdoptionCard>
  )
}
